/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { Col, Row, ButtonGroup, ButtonToolbar, Button } from 'reactstrap'

import ConfirmationModal from '../widgets/ConfirmationModal'
import { AppContext } from '../AppContext'

class ApiErrorLog extends React.Component
{
  columnKey = 'apiErrorLog.columnWidths';
  debouncedSaveColumnWidths = null;
  columnWidths = {};

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    this.fetchApiErrors();
  }

  confirmPurgeApiErrors(event)
  {
    this.setState({confirmationModalIsOpen: true});
  }

  constructor(props)
  {
    super();

    const columns = 
    [
      {Header: 'Timestamp', id: 'errorTimestamp', accessor: d => {return d.errorTimestamp},
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.errorTimestamp, true)}>{window.formatTimestamp(rowInfo.row.errorTimestamp, false)}</span></div>)},
      {Header: 'Username', id: 'username', accessor: 'username', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Error-ID', id: 'errorId', accessor: d => {return d.errorId}, 
        Cell: rowInfo => <div><span title={rowInfo.row.errorId}>{rowInfo.row.errorId}</span></div>},
      {Header: 'Error Code', id: 'errorCode', accessor: 'errorCode', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Error Message', id: 'errorMessage', accessor: 'errorMessage', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Json Parameters', id: 'jsonParameters', accessor: 'jsonParameters', 
        Cell: row => <div><span title={JSON.stringify(row.value)}>{JSON.stringify(row.value)}</span></div>}

    ];

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.state =
    {
      apiErrorLogData: [],
      columns: columns,
      confirmationModalIsOpen: false
    }

    this.confirmPurgeApiErrors = this.confirmPurgeApiErrors.bind(this);
    this.fetchApiErrors = this.fetchApiErrors.bind(this);
    this.purgeApiErrors = this.purgeApiErrors.bind(this);
  }

  async fetchApiErrors()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getApiErrorLog');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading API Error Log data');

/*    let dbTwigErrors = await this.context.dbTwig.callRestAPI('dgBunker', 'getDbTwigErrors');
    if ('success' !== dbTwigErrors.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving dbTwig errors'); */

    this.setState({apiErrorLogData: result.jsonData.apiErrorLog});
  }

  async purgeApiErrors(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;
    
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'purgeApiErrors');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error purging API Error Log');

    this.context.postNotification('info', 'API error log has been purged.');
    this.setState({apiErrorLogData: undefined});
  }

  render()
  {
    let modalText = 'Are you sure you want to purge the API error log?';

    document.title = this.context.websiteProfile.profileName + ': API Error Log';

    return(
      <div>
        <Col>
          <Row>
            <ButtonToolbar>
              <ButtonGroup size="sm" >
                <Button color="transparent" title="Refresh" onClick={this.fetchApiErrors}><img src="assets/images/refresh.png" alt="Refresh" /></Button>
                <Button color="transparent" title="Purge Error Log" onClick={this.confirmPurgeApiErrors}><img src="assets/images/trash.png" alt="Purge" /></Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Row>
          <Row>
            <ReactTable data={this.state.apiErrorLogData} columns={this.state.columns} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)}
            />
          </Row>            
        </Col>        
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.purgeApiErrors}
          modalText={modalText}
        />
      </div>
    ); 
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);
  }
}

ApiErrorLog.contextType = AppContext;

export default ApiErrorLog;
